import React from 'react';
import { IDSAlert } from '@inera/ids-react';

/**
 * Renders an error or success message as a dismissible IDS alert.
 *
 * When an error has origin="SERVER" and an errorCode, a small copyable
 * badge is shown so the user can reference the code when contacting support.
 *
 * Props:
 *   error       — error message string, or an Error object with .errorCode / .origin
 *   success     — success message string
 *   className   — wrapper CSS class (default 'ids-mb-4')
 */
const StatusAlert = ({ error, success, className = 'ids-mb-4' }) => {
  const isErrorObj = error && typeof error === 'object';
  const message    = isErrorObj ? error.message : (error || success);
  const errorCode  = isErrorObj ? error.errorCode : null;
  const isServer   = isErrorObj ? error.origin === 'SERVER' : false;

  if (!message) return null;

  return (
    <div className={className}>
      <IDSAlert key={message} dismissible ribbon type={error ? 'error' : 'success'}>
        <span>{message}</span>
        {error && isServer && errorCode && (
          <span
            title="Referenskod — ange denna om du kontaktar support"
            style={{
              display: 'inline-block',
              marginLeft: '0.6rem',
              padding: '0.1rem 0.45rem',
              fontSize: '0.75rem',
              fontFamily: 'monospace',
              background: 'rgba(0,0,0,0.08)',
              borderRadius: '3px',
              cursor: 'pointer',
              userSelect: 'all',
            }}
            onClick={() => navigator.clipboard?.writeText(errorCode)}
          >
            {errorCode}
          </span>
        )}
      </IDSAlert>
    </div>
  );
};

export default StatusAlert;
